module.exports = __webpack_public_path__ + "static/img/ent-71.64e05ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-71.jpg
// module id = rz89
// module chunks = 52